export default __webpack_public_path__ + "static/media/kore2.0-logo-wh.b24c1755.png";